/**
 * Created by coolguy on 2018/8/8.
 */
import React from 'react';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import intl from 'react-intl-universal';
import './index.scss';
import { OneComment, NoComments } from './OneComment';
import BottomFixWrapper from './BottomFixWrapper';
import { debounce } from '../../utils/util';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import { ThemeContext } from '../../store/ThemeProvider';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import ReactSVG from 'react-svg';
import chroma from 'chroma-js';
import { alpha } from '../../utils/color';

@inject('rootStore')
@observer
class BottomComment extends React.Component {
  constructor(props) {
    super(props);
    if (props && props.tab && typeof props.tab === 'number') {
      this.switchTab(props.tab);
    }
  }
  containerEl = document.createElement('div');

  @observable tabIndex = 0;

  @action switchTab = currentIndex => {
    this.tabIndex =
      currentIndex === undefined ? (this.tabIndex + 1) % 2 : currentIndex;
  };
  onDelete = id => {
    this.props.onDelete(id);
  };
  close = () => {
    this.props.close && this.props.close();
  };
  loadMore = debounce(() => {
    if (!this.props.finished) {
      this.props.getList && this.props.getList();
    } else {
      console.log('到底了哦');
    }
  });

  clickRedPack = (type, id, { content, postname, postphoto }) => {
    //红包
    if (type === 'redpack') {
      const { redPackStore } = this.props.rootStore;
      redPackStore.setRedPackList([{ id, content, postname, postphoto }]);
    }
  };

  scroll = e => {
    const { target } = e;
    const { scrollTop, offsetHeight, scrollHeight } = target;
    const tolerate = 300;
    // 离底部还有tolerate后加载更多
    const delta = scrollTop >= scrollHeight - offsetHeight - tolerate;
    if (delta) {
      //console.log(delta);
      this.loadMore();
    }
  };

  componentWillUnmount() {
    clearAllBodyScrollLocks();
    document.body.removeChild(this.containerEl);
  }
  componentDidMount() {
    disableBodyScroll(document.querySelector('.bottom-comment'), {
      allowTouchMove: el => {
        while (el && el !== document.body) {
          if (el.classList.contains('bottom-comment-list')) {
            return true;
          }

          el = el.parentNode;
        }
      }
    });
    document.body.appendChild(this.containerEl);
  }

  render() {
    const { list, topList, finished, total, rootStore } = this.props;
    const isempty = total < 1;

    return createPortal(
      <ThemeContext.Consumer>
        {theme => (
          <div
            className={classNames(
              'bottom-comment-wrapper',
              this.props.classNames
            )}
            onClick={this.close}
          >
            <div className="bottom-comment">
              <div
                className="bottom-comment-main"
                style={Object.assign(
                  {
                    backgroundColor: theme.backgroundColor
                  },
                  { marginBottom: 0 }
                )}
                onClick={e => e.stopPropagation()}
              >
                <div
                  className="bottom-comment-title"
                  style={{
                    borderTopColor: alpha(theme.h1Color, 0.1),
                    borderBottomColor: alpha(theme.h1Color, 0.1),
                    backgroundColor: theme.componentColor
                  }}
                >
                  <div
                    className={
                      'one-title ' + (this.tabIndex === 0 ? 'active' : '')
                    }
                    onClick={this.switchTab.bind(this, 0)}
                    style={{ color: theme.h1Color }}
                  >
                    {intl.get('All comments')}
                    <span
                      className="sub-title"
                      style={{ color: theme.h2Color }}
                    >
                      ({total || 0})
                    </span>
                  </div>
                  <ReactSVG
                    src={require('../../svg/x.svg')}
                    className="x"
                    style={{ fill: theme.h2Color }}
                    onClick={this.props.close}
                  />
                </div>
                {this.tabIndex === 0 && (
                  <div
                    className="bottom-comment-list"
                    style={{ backgroundColor: theme.componentColor }}
                    onScroll={this.scroll}
                  >
                    {topList.length
                      ? topList.map(one => {
                          return (
                            <OneComment
                              {...one}
                              key={one.id}
                              onClick={this.clickRedPack}
                              h1Color={theme.h1Color}
                              h2Color={theme.h2Color}
                              mainColor={theme.mainColor}
                            />
                          );
                        })
                      : null}
                    {list.length
                      ? list.map(one => {
                          return (
                            <OneComment
                              {...one}
                              key={one.id}
                              onClick={this.clickRedPack}
                              h1Color={theme.h1Color}
                              h2Color={theme.h2Color}
                              mainColor={theme.mainColor}
                              onDelete={
                                one.openid == rootStore.wxuserStore.user.openid
                                  ? () => this.onDelete(one.id)
                                  : null
                              }
                            />
                          );
                        })
                      : null}
                    {isempty ? (
                      <NoComments color={alpha(theme.h1Color, 0.6)} />
                    ) : (
                      <div className="load-more" onClick={this.loadMore}>
                        {finished
                          ? intl.get('This is the end', { words: 'comments' })
                          : intl.get('Load more')}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <BottomFixWrapper submit={this.props.submit} />
          </div>
        )}
      </ThemeContext.Consumer>,
      this.containerEl
    );
  }
}

export default BottomComment;
